import { reactive, toRefs, computed } from 'vue'
import { getTCEGoodsCollections } from '@/services/api/goods'
import { Language } from '@/constants/language'
import { i18n } from './language'
import { defineStore } from '../store'

export const useGoodsCollectionStore = defineStore(() => {
    const state = reactive({
        loading: false,
        goodsCollections: <Model.TCEGoodsCollectionRsp[]>[], // 商品集合信息
    })

    // 本地化商品集合
    const collections = computed<Model.TCEGoodsCollectionRsp[]>(() => state.goodsCollections.map((e) => {
        const localizedProperties: { [K in Language]: { [P in 'collectionname' | 'collectiondesc']: string } } = {
            'zh-CN': { collectionname: e.collectionname, collectiondesc: e.collectiondesc, },
            'en-US': { collectionname: e.collectionnameen, collectiondesc: e.collectiondescen, },
            'th': { collectionname: e.collectionnameth, collectiondesc: e.collectiondescth, },
            'zh-TW': { collectionname: e.collectionnametw, collectiondesc: e.collectiondesctw, },
            'vi': { collectionname: e.collectionnamevi, collectiondesc: e.collectiondescvi, },
        }

        const localizedValues = localizedProperties[i18n.global.locale] // 本地化语言

        return {
            ...e,
            ...localizedValues
        }
    }))

    // 根据商品 ID 查找对应的商品信息
    const getGoodsById = (id: number) => collections.value.find((e) => e.collectionid === id)

    // 获取商品集合列表
    const fetchGoodsCollections = async () => {
        try {
            if (!state.loading) {
                state.loading = true
                const res = await getTCEGoodsCollections()
                state.goodsCollections = res.data.filter((e) => e.collectionstatus === 1)
            }
        } finally {
            state.loading = false
        }
    }

    return {
        ...toRefs(state),
        collections,
        fetchGoodsCollections,
        getGoodsById
    }
})